import React from "react";
import {Table, Button, Modal} from "react-bootstrap";
import {copyToClipboard} from "tools";

class TicketCreated extends React.Component {

	constructor(props, context) {
		super(props, context);

		this.handleCopyToClipboard = this.handleCopyToClipboard.bind(this);
	}

	handleCopyToClipboard() {
		const {tickets} = this.props;
		const text = tickets
			.map(ticket => `${location.protocol}//${location.host}/watch/${ticket.ticket}`)
			.join('\n');

		copyToClipboard(text, this.copyContainer);
	}

	render() {
		const {tickets, show, onHide} = this.props;

		return (
			<Modal show={show} onHide={onHide} bsSize="large">
				<Modal.Header closeButton>
					<Modal.Title>Новые билеты</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<section ref={ref => this.copyContainer = ref} />

					<Table responsive>
						<thead>
						<tr>
							<th>eMail</th>
							<th width={700}>Ссылка</th>
						</tr>
						</thead>
						<tbody>
						{tickets.map(ticket =>
							<tr key={ticket.id}>
								<td>{ticket.email}</td>
								<td>{`https://${location.host}/watch/${ticket.ticket}`}</td>
							</tr>
						)}
						</tbody>
					</Table>
				</Modal.Body>
				<Modal.Footer>
					<Button onClick={this.handleCopyToClipboard}>Скопировать в буфер</Button>
					{/*<Button>Скачать в формате Excel</Button>*/}
					<Button onClick={onHide}>Закрыть</Button>
				</Modal.Footer>
			</Modal>
		);
	}

}

export default TicketCreated;
